<script setup>
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import ErrorBoundary from "@/components/shared/error-boundary/ErrorBoundary";
import SnsLogo from "@/components/ui/SnsLogo.vue";
import { checkIfSubscriptionExpired } from "@/composables/useCheckLicense.js";
import SidebarLayout from "@/layouts/SidebarLayout";

const store = useStore();
const route = useRoute();

const isUserLoading = computed(() => store.getters.isUserLoading);

checkIfSubscriptionExpired();

watch(
  () => route.path,
  () => {
    document.body.style.overflow = "initial";
    document.body.style.maxHeight = "initial";
    checkIfSubscriptionExpired();
  },
);
</script>

<template>
  <div>
    <ErrorBoundary :name="$route.path">
      <div v-if="isUserLoading" class="flex items-center justify-center min-h-screen bg-base-100">
        <SnsLogo image-class="!w-48 animate-pulse" :disable-link="true" />
      </div>

      <template v-else>
        <main class="dashboard-layout">
          <SidebarLayout />
          <div class="dashboard-layout-inner">
            <div class="dashboard-layout-container">
              <router-view v-slot="{ Component, route: currentRoute }">
                <keep-alive :include="['ApiDocsPage']">
                  <component :is="Component" :key="currentRoute.path" />
                </keep-alive>
              </router-view>
            </div>
          </div>
        </main>
      </template>
    </ErrorBoundary>
  </div>
</template>

<style lang="scss" scoped>
.dashboard-layout {
  min-height: fit-content;
  transition: background-color 0.2s ease;

  .dashboard-layout-inner {
    margin-left: var(--sidebar-width, #{$sidebar-min-width});

    @media screen and (max-width: $screen-size-tablet) {
      margin-left: 0;
    }

    .dashboard-layout-container {
      margin: 0 auto;
      padding: 1.5rem 1rem;
      max-width: 1920px;
    }
  }
}
</style>
